// 選択したタグをテキストボックスと相互反映

wishListDelete()
function wishListDelete() {
  const wishList = document.getElementById('wishDelete')
  if (!wishList) {
    return
  }

  window.addEventListener('change', function (e) {
    // 指定のクラスを持つ
    if (e.target.classList.contains('js-wishDelete')) {
      tag2textBox(e.target)
    }
  })

  // 全選択に追従する
  window.addEventListener('change', function (e) {
    // 指定のクラスを持つ
    if (e.target.classList.contains('js-allCheck')) {
      setTimeout(() => {
        tag2textBox(e.target)
      }, 300)
    }
  })

  // 削除ボタンのアクション
  document.getElementById('wishDelete-done').addEventListener('click', function (e) {
    setTimeout(() => {
      deleteAction()
    }, 300)
  })

  // タグの変化をテキストボックスに反映
  function tag2textBox(item) {
    let list = activeTag2list()

    list = listFix(list)
    list2input(list)
  }

  // 配列を整理する
  function listFix(list) {
    list = new Set(list) // 配列の重複を除去
    list = Array.from(list) // Setでオブジェクト型に変わったため配列に戻す
    list = list.filter((v) => v) // 配列の空要素を除去
    return list
  }

  // 配列を送信IDにセットする
  function list2input(list) {
    const text = list.join(',') // 配列を文字列に変換
    wishList.value = text

    doneToggle(text !== '')
  }

  // 送信ボタンの押下許可を切り替える
  function doneToggle(flag) {
    const done = document.getElementsByClassName('js-wishDelete-done')
    if (flag) {
      for (const iterator of done) {
        iterator.classList.remove('is-disable')
      }
    } else {
      for (const iterator of done) {
        iterator.classList.add('is-disable')
      }
    }
  }

  // 選択されている動画を配列で返す
  function activeTag2list() {
    const videos = document.getElementsByClassName('js-wishDelete')
    let list = []
    for (const item of videos) {
      if (!item.checked) {
        continue
      }
      list.push(item.value) // 配列の末尾に追加
    }
    list = listFix(list) // 配列を整理する
    return list
  }

  // チェックした動画の削除アクション
  function deleteAction() {
    // 選択情報を空にする
    wishList.value = ''

    doneToggle(false)

    const videos = document.getElementsByClassName('js-wishDelete')
    for (const item of videos) {
      if (!item.checked) {
        continue
      }
      // チェックを外す
      item.checked = false
      // 削除アニメーション
      document.getElementById('item-' + item.value).classList.add('deleted')

      // 全選択の対象から外す
      item.classList.remove('js-allCheck--wish')
    }

    const allCheck = document.getElementsByClassName('js-allCheck')
    for (const item of allCheck) {
      if (!item.checked) {
        continue
      }
      // チェックを外す
      item.checked = false
    }
  }
}
